package io.horion.auth.di

val appModules = listOf(
    repositoryModule,
    useCaseModule,
    viewModelModule
)